module.exports = __webpack_public_path__ + "static/img/ewm1.5102078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ewm1.png
// module id = VehB
// module chunks = 1